
import { AbstractDisplayComponent } from "./AbstractDisplayComponet";
import { IComponentFactory } from "./DisplayComponentFactory";

export class DisplayComponent {

    public static init() {
        this.constructed = true;
        this.components.forEach((component) => component.init());
    }

    public static register(factory: IComponentFactory) {

        const addComponent = () => DisplayComponent.components.push(factory.initialize());

        this.constructed = true;
        addComponent();
    }

    public static get<T extends AbstractDisplayComponent>(type: { new(...args: any[]): T }): T {
        const found = DisplayComponent.components.filter((value) => value instanceof type) as T[];
        return found[0];
    }


    public static getAll<T extends AbstractDisplayComponent>(type: { new(...args: any[]): T }): T[] {
        return DisplayComponent.components.filter((value) => value instanceof type) as T[];
    }

    public static unregister<T extends AbstractDisplayComponent>(type: { new(...args: any[]): T }) {
        const componentsToRemove = DisplayComponent.components.filter((value) => value instanceof type);
        componentsToRemove.forEach(component => component.destroy());

        DisplayComponent.components = DisplayComponent.components.filter((value) => !(value instanceof type));
    }

    protected static constructed: boolean = false;
    private static components: AbstractDisplayComponent[] = [];
}
